import React from 'react';

type Props = {
  isVisible: boolean;
  open: boolean;
  onExpand: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  isInSubrow?: boolean;
};

export const ExpandRowChevron: React.FC<Props> = ({
  isVisible,
  open,
  onExpand,
  isInSubrow,
}): JSX.Element => {
  const needRotate = open ? 'rotate(90deg)' : 'none';

  const defineVisibility = isVisible || isInSubrow ? 'flex' : 'none';

  const hidden = isInSubrow ? 'hidden' : '';
  return (
    <div
      onClick={onExpand}
      className={`${hidden} expand-row-icon`}
      style={{ display: defineVisibility }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: needRotate, transition: 'all 0.2s linear' }}
      >
        <path
          d="M5.52851 2.86195C5.26816 3.1223 5.26816 3.54441 5.52851 3.80476L9.72378 8.00002L5.52851 12.1953C5.26816 12.4556 5.26816 12.8777 5.52851 13.1381C5.78886 13.3984 6.21097 13.3984 6.47132 13.1381L11.138 8.47142C11.3983 8.21108 11.3983 7.78896 11.138 7.52862L6.47132 2.86195C6.21097 2.6016 5.78886 2.6016 5.52851 2.86195Z"
          fill="#8189A1"
        />
      </svg>
    </div>
  );
};
